import { createSlice, PayloadAction } from "@reduxjs/toolkit";


export interface BackTriggeredStates {
    last_back_triggered_time: string;
    is_back_triggered: boolean;
}

const initialState: BackTriggeredStates = {
  last_back_triggered_time: "",
  is_back_triggered: false
};


const BackTriggeredSlice = createSlice({
  name:"Back Trigger Slice",
  initialState,
  reducers:{
    setLastBackTriggeredTime: (state, action: PayloadAction<string>) => {
      state.last_back_triggered_time = action.payload
    },
    setBackTriggered: (state, action: PayloadAction<boolean>) => {
      state.is_back_triggered = action.payload
    }
  },
  extraReducers: {}
});


export const { setLastBackTriggeredTime, setBackTriggered } = BackTriggeredSlice.actions;

export default BackTriggeredSlice.reducer;